import { render, staticRenderFns } from "./CytomineModalCard.vue?vue&type=template&id=32a7360b&scoped=true"
import script from "./CytomineModalCard.vue?vue&type=script&lang=js"
export * from "./CytomineModalCard.vue?vue&type=script&lang=js"
import style0 from "./CytomineModalCard.vue?vue&type=style&index=0&id=32a7360b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a7360b",
  null
  
)

export default component.exports